import { UseAthleteOverview } from "@/components/athlete-overview-page/athlete-overview-page-provider";
import { PodiumCard } from "@/components/athlete-overview-page/athlete-podium/podium-card";

export function AthleteOverviewPodium() {
    const { data } = UseAthleteOverview()
    const { podium } = data
    return (
        <div className="w-full flex flex-col pr-10 md:pr-0 md:pt-[50px] md:flex-row gap-4 items-end">
            {podium.map((position) => (
                <PodiumCard key={position.id} {...position} />
            ))}
        </div>
    )
} 
